import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export function VideoCarouselInfoBox() {
  return (
    <Box
      sx={{
        mt: 3,
        bgcolor: 'grey.50',
        borderRadius: 3,
        p: 2,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
      }}
    >
      <InfoOutlinedIcon sx={{ color: 'info.main', fontSize: 20, mt: 0.25 }} />
      <Typography variant="body2" color="text.secondary">
        Skapa anpassade videokaruseller genom att söka och välja videor.
      </Typography>
    </Box>
  );
}
